import styled from 'styled-components';


export default styled.div`
    max-width:800px;
    width:100%;
    margin: 0 auto;
    
`